$(document).ready(function() {
    // Initialize image map resizer if the plugin is available
    if (typeof $.fn.imageMapResize === 'function') {
        $('map[name="desktop-map"] , map[name="mobile-map"]').imageMapResize();
    }

    // Handle click and touch events on map areas
    $('map[name="desktop-map"] area, map[name="mobile-map"] area').on('click touchstart', function(e) {
      //alert(2);
        e.preventDefault();
        console.log('Area clicked or touched'); // Debugging line
        var slideIndex = $(this).data('slide-index');
        if (typeof slideIndex === 'undefined') return; // Check if slideIndex exists
        var targetSection = $('.map_info_item').eq(slideIndex);
        if (targetSection.length === 0) return; // Ensure the target section exists
        var targetOffset = targetSection.offset().top;
        $('html, body').animate({
            scrollTop: targetOffset
        }, 1500);
    });

    // Handle hover and touch events for image map areas
    $('map[name="desktop-map"] area, map[name="mobile-map"] area').on('mouseenter touchstart', function() {
        const coords = $(this).attr('coords').split(',').map(Number);
        if (coords.length < 4) return; // Ensure there are enough coordinates

        const [left, top, right, bottom] = coords;
        const image = $(this).closest('map').siblings('img:visible');
        if (image.length === 0) return; // Ensure the image exists

        const imageWidth = image.width();
        const imageHeight = image.height();

        const leftPercent = (left / imageWidth) * 100;
        const topPercent = (top / imageHeight) * 100;
        const widthPercent = ((right - left) / imageWidth) * 100;
        const heightPercent = ((bottom - top) / imageHeight) * 100;

        $('#hover-overlay').css({
            position: 'absolute',
            left: `${leftPercent}%`,
            top: `${topPercent}%`,
            width: `${widthPercent}%`,
            height: `${heightPercent}%`,
            display: 'block'
        });
    }).on('mouseleave touchend', function() {
        $('#hover-overlay').css('display', 'none');
    });

    // Ensure the parent container of the image is relatively positioned
    $('.map-image-main img').each(function() {
        const $parent = $(this).parent();
        if ($parent.css('position') !== 'relative') {
            $parent.css({
                position: 'relative',
                display: 'inline-block'
            });
        }
    });

    // Ensure proper viewport meta tag in HTML
    if (!$('meta[name="viewport"]').length) {
        $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1.0">');
    }
});
